import { gql } from '@apollo/client';

export default gql`
  query bookingsByAdditionalDetails($key: String!, $value: String!) {
    bookingsByAdditionalDetails(key: $key, value: $value) {
      reference
      expiryTimestamp
      status
      additionalDetails {
        value
        key
        itemRef
      }
      outboundExtras {
        type
      }
      inboundExtras {
        type
      }
      externalBookingReferences {
        source
        type
        externalId
      }
      customer {
        firstName
        lastName
      }
      passengers {
        id
      }
      outbound {
        timing {
          date
        }
        serviceName
        origin {
          shortCode
          shortName
          name
        }
        destination {
          shortCode
          shortName
          name
        }
        timing {
          isoDate
        }
        products {
          cancelled
          passengerId
          seat {
            carriage
            seatNumber
          }
        }
        extraProducts {
          cancelled
          type
          name
          passengerId
        }
      }
      inbound {
        timing {
          date
        }
        serviceName
        origin {
          shortCode
          shortName
          name
        }
        destination {
          shortCode
          shortName
          name
        }
        timing {
          isoDate
        }
        products {
          cancelled
          passengerId
          seat {
            carriage
            seatNumber
          }
        }
        extraProducts {
          cancelled
          type
          name
          passengerId
        }
      }
    }
  }
`;
